// The picture or sound slot on a question card or a word (components/MediaSlot).
const mediaSlot = {
  en: {
    addImage: 'Add a picture',
    addAudio: 'Add a sound',
    replace: 'Replace',
    remove: 'Remove',
    dropHint: 'or drop it here',
    uploading: 'Uploading… {percent}%',
    imageAlt: 'Picture of this item',
    wrongImageType: 'Use a PNG, JPG, WEBP or GIF picture.',
    wrongAudioType: 'Use an MP3, M4A, OGG, WAV or WEBM sound.',
    tooBig: 'The file is larger than {mb} MB.',
    failed: 'Could not upload the file. Try again.',
    forbidden: 'You cannot upload files here.',
    wordPicture: 'Picture',
    wordPictureHint: 'Used by the Picture quiz game. It is saved at once.',
    wordAudio: 'Pronunciation',
    pictureSaveFailed: 'Could not attach the picture to the word.',
  },
  ru: {
    addImage: 'Добавить картинку',
    addAudio: 'Добавить звук',
    replace: 'Заменить',
    remove: 'Убрать',
    dropHint: 'или перетащите сюда',
    uploading: 'Загрузка… {percent}%',
    imageAlt: 'Картинка к этому элементу',
    wrongImageType: 'Нужна картинка PNG, JPG, WEBP или GIF.',
    wrongAudioType: 'Нужен звук MP3, M4A, OGG, WAV или WEBM.',
    tooBig: 'Файл больше {mb} МБ.',
    failed: 'Не удалось загрузить файл. Попробуйте ещё раз.',
    forbidden: 'У вас нет права загружать файлы сюда.',
    wordPicture: 'Картинка',
    wordPictureHint: 'Нужна для игры «Викторина с картинками». Сохраняется сразу.',
    wordAudio: 'Произношение',
    pictureSaveFailed: 'Не удалось прикрепить картинку к слову.',
  },
  uz: {
    addImage: "Rasm qo'shish",
    addAudio: "Ovoz qo'shish",
    replace: 'Almashtirish',
    remove: 'Olib tashlash',
    dropHint: 'yoki shu yerga tashlang',
    uploading: 'Yuklanmoqda… {percent}%',
    imageAlt: 'Shu bandning rasmi',
    wrongImageType: 'PNG, JPG, WEBP yoki GIF rasm tanlang.',
    wrongAudioType: 'MP3, M4A, OGG, WAV yoki WEBM ovoz tanlang.',
    tooBig: 'Fayl {mb} MB dan katta.',
    failed: "Faylni yuklab bo'lmadi. Qayta urinib ko'ring.",
    forbidden: "Bu yerga fayl yuklashga ruxsatingiz yo'q.",
    wordPicture: 'Rasm',
    wordPictureHint: "«Rasmli viktorina» o'yini uchun kerak. Darhol saqlanadi.",
    wordAudio: 'Talaffuz',
    pictureSaveFailed: "Rasmni so'zga biriktirib bo'lmadi.",
  },
};

export default mediaSlot;
